export default [{
    path: '/perfil',
    name: 'perfil',
    component: () =>
        import ('@/views/pages/perfil/Perfil.vue'),
    meta: {
		title: 'i18n:perfil.title',
        resource: 'Publico',
        action: 'ver-publico',
        redirectIfNoEmpresa: true,
        pageTitle: 'Perfil',
        breadcrumb: [{
            text: 'Perfil',
            active: true,
        }, ],
    },
}, ]
